export default __webpack_public_path__ + "static/media/sufiyan.1ba21cc0.jpg";